import React from 'react'
import { NextPage } from 'next'
import type { ArticlePreviewPageProps } from '../../components/articlePreview/interfaces'
import ArticlePreview from '../../components/articlePreview/ArticlePreview'
import HypotenuseLogoText from '../../components/logos/HypotenuseLogoText'
import ArticlePreviewSEO from '../../components/articlePreview/ArticlePreviewSEO'
import {
  makeStaticPathsGetter,
  makeStaticPropsGetter
} from '../../components/articlePreview/dataFetchers'
import { phoenixApiClient } from '../../lib/api/apiClients'

/**
 * Publicly viewable article preview page
 */
const PhoenixArticlePreviewPage: NextPage<ArticlePreviewPageProps> = (
  props
) => {
  const { articlePreview } = props

  return (
    <>
      <ArticlePreviewSEO articlePreview={articlePreview} />
      <ArticlePreview
        articlePreview={articlePreview}
        logo={<HypotenuseLogoText light priority />}
      />
    </>
  )
}
export default PhoenixArticlePreviewPage

export const getStaticProps = makeStaticPropsGetter({
  apiClient: phoenixApiClient
})

export const getStaticPaths = makeStaticPathsGetter()
